// extracted by mini-css-extract-plugin
module.exports = {"container":"SecondaryTools_container__36dip","tagButton":"SecondaryTools_tagButton__25IGV","deleteButton":"SecondaryTools_deleteButton__1fQNn"};